import query from '@/components/query/query-constructor';
import { replaceReportRoute, reportRouteParams } from '@/components/query/report-route-query';
import { useReportParams } from '@/composables/useReportParams';
import type { PickUrlContext } from '@/views/reports/pickers/base/utils';

export const pushURL = (ctx: PickUrlContext, cb?: () => void) => {
  const savedColumnsInCurentPreset = useReportParams().savedColumnsInCurentPreset.value;
  if (ctx.$route.name !== 'app.conversions' || !savedColumnsInCurentPreset) return;

  const { columns, order, context } = savedColumnsInCurentPreset.conversions;

  const {
    from,
    to,
    timezone,
    date,
    compareFrom,
    compareTo,
    compareDate,
    compareEnabled,
    currency,
    limit,
    offset,
  } = ctx.getTableQueryForCurrentTab() as Record<string, unknown>;

  const data = query.get({
    from,
    to,
    timezone,
    date,
    compareFrom,
    compareTo,
    compareDate,
    compareEnabled,
    currency,
    limit,
    offset: (offset as Record<string, number>)[context],
    ...order,
    columns,
    groupBy: context,
  });

  replaceReportRoute(ctx.$router, {
    name: 'app.conversions',
    params: {
      data: data,
      report: ctx.$route.params.report,
      ...reportRouteParams({ manual: true, picker: true }),
    },
  }, cb);
};
